exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.tofu-icon-component {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n}\n.tofu-icon-component .icon-font {\n    display: inline-block;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n}\n.tofu-icon-component .icon-image {\n    position: absolute;\n    top: 50%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-13c5220e!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tofu-icon/src/icon.vue
// module id = 457
// module chunks = 0